import { HELP_KEEP_MESSAGE } from '../../../facade/js/measureconfiguracionihm';

import Measureihm from './measurebaseihm';
import FacadeMeasureihm from '../../../facade/js/measurebaseihm';
import FacadeMeasureCirculoihm from '../../../facade/js/measurecirculoihm';

/**
 * @classdesc
 * Main constructor of the class. Creates a MeasureConfiguracionihm
 * control
 *
 * @constructor
 * @extends {M.impl.control.Measureihm}
 * @api stable
 */
export default class MeasureConfiguracionihm extends Measureihm {
  constructor() {
    super('');

    /**
     * Help message
     * @private
     * @type {string}
     */
    this.helpMsg_ = FacadeMeasureihm.HELP_MESSAGE;

    /**
     * Help message
     * @private
     * @type {string}
     */
    this.helpMsgContinue_ = HELP_KEEP_MESSAGE;
    this.checked = ['rumbo', 'segmento', 'continuo'];

    this.eventMap = false;

    this.setEventCheck(true);
  }

  setChecked(valor) {
    this.checked = valor;
  }
  getChecked() {
    return this.checked;
  }

  setEventCheck(valor) {
    this.eventMap = valor;
  }
  getEventCheck() {
    return this.eventMap;
  }

  /**
   * This function add tooltip with measureihm distance
   * @public
   * @param {ol.geom.SimpleGeometry} geometry - Object geometry
   * @return {string} output - Indicates the measureihm distance
   * @api stable
   */
  formatGeometry(geometry) {}
  /**
   * This function returns coordinates to tooltip
   * @public
   * @param {ol.geom.SimpleGeometry} geometry - Object geometry
   * @return {array} coordinates to tooltip
   * @api stable
   */
  getTooltipCoordinate(geometry) {
    // return geometry.getLastCoordinate();
  }

  activate() {
    const measureCirculo = this.facadeMap_.getControls().filter((control) => {
      return (control instanceof FacadeMeasureCirculoihm);
    })[0];

    if (measureCirculo) {
      measureCirculo.deactivate();
    }
    // super.activate();
    document.querySelector('.m-measureconfiguracionihm-container').classList.add('activated');
  }

  /* eslint-disable newline-per-chained-call */
  formatNumber(number) {
    return `${number}`.replace(/\d(?=(\d{3})+\.)/g, '$&*').split('.').join(',').split('*').join('.');
  }
}

/**
 * Name to identify this control
 * @const
 * @type {string}
 * @public
 * @api stable
 */
MeasureConfiguracionihm.checked = [];
